<span class="doc-status" [ngSwitch]="visibleKind">
    <ng-container *ngSwitchCase="'Indexed'">
        <span class="doc-ok">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6">
                <path d="M20 6L9 17l-5-5" />
            </svg>
            Indexed
        </span>
    </ng-container>
    <ng-container *ngSwitchCase="'Indexing'">
        <span class="doc-wait">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 7v5l3 2" />
            </svg>
            Indexing…
        </span>
    </ng-container>
    <ng-container *ngSwitchCase="'Failed'">
        <span class="doc-fail" [attr.title]="failureReason || 'Indexing failed'">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6">
                <path d="M18 6L6 18M6 6l12 12" />
            </svg>
            Failed
            <button
                *ngIf="!readOnly"
                type="button"
                class="doc-retry"
                title="Retry indexing"
                (click)="onRetry($event)"
            >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                    <path d="M21 2v6h-6M3 12a9 9 0 0115-6.7L21 8" />
                </svg>
                Retry
            </button>
        </span>
    </ng-container>
</span>
